const evaluationTab = Object.freeze({
  Educativos: 0,
  Relacionados: 1,
});

export default evaluationTab;
